export default "__VITE_ASSET__DhRuChzj__"